// The title's slot roll, the slider's glide and the count on a Slow ⇄ Fast
// flip all run together; CSS reads the same timing from --roll-duration and
// --roll-ease (popup/css/system/transitions.css).
export const ROLL_MS = 350;

export function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
  );
}
